const KEY = "jobsmith_aff";
const WINDOW_DAYS = 30;

function getRecord() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const rec = JSON.parse(raw);
    if (Date.now() - rec.ts > WINDOW_DAYS * 864e5) {
      localStorage.removeItem(KEY);
      return null;
    }
    return rec;
  } catch {
    return null;
  }
}

// First-touch, permanent within the 30-day window: never overwrite an existing capture.
export function captureAff(search) {
  const params = new URLSearchParams(search || window.location.search);
  const code = params.get("aff");
  if (!code) return;
  if (getRecord()) return;
  localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), ts: Date.now() }));
}

export function getAff() {
  const rec = getRecord();
  return rec ? rec.code : null;
}

export function clearAff() {
  localStorage.removeItem(KEY);
}
